import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import {vtmT} from '../i18n';
import '../../styles/vtm/roll.css';

/** Le personnage se nourrit : on choisit la Soif après le repas, annoncée dans le chat. */
const VtmFeedModal = ({isOpen, onClose, character, actions}) => {
  const hunger = character.vtm.hunger;
  const [target, setTarget] = useState(Math.max(0, hunger - 1));
  const [note, setNote] = useState('');
  const [hidden, setHidden] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTarget(Math.max(0, hunger - 1));
      setNote('');
      setHidden(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const submit = async () => {
    setBusy(true);
    try {
      await actions.feed({newHunger: target, note, hidden});
      onClose();
    } catch (e) {
      console.log(e);
    }
    setBusy(false);
  };

  // Soif possibles après le repas : de la Soif actuelle − 1 jusqu'à 0
  const options = Array.from({length: hunger}, (_, index) => hunger - 1 - index);

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="vtmModal" overlayClassName="vtmModalOverlay" contentLabel={vtmT('feedCheck')}>
      <div className="vtmModalHeader">
        <h2 className="vtmModalTitle">{vtmT('feedCheck')}</h2>
        <span className="vtmModalSubtitle">{character.name}</span>
      </div>
      <form className="vtmRollForm" onSubmit={event => { event.preventDefault(); submit(); }}>
        <fieldset className="vtmField vtmFeedChoices">
          <legend className="vtmFieldLabel">{vtmT('feedHungerAfter', {value: hunger})}</legend>
          <div className="vtmFeedOptions">
            {options.map(value => (
              <button
                key={value}
                type="button"
                className={`vtmFeedOption${value === target ? ' selected' : ''}`}
                aria-pressed={value === target}
                onClick={() => setTarget(value)}
              >
                {value}
              </button>
            ))}
          </div>
          {target === 0 && <p className="vtmHint">{vtmT('feedZeroHint')}</p>}
        </fieldset>
        <div className="vtmField">
          <label className="vtmFieldLabel" htmlFor="vtmFeedNote">{vtmT('feedNote')}</label>
          <input id="vtmFeedNote" type="text" value={note} placeholder={vtmT('feedNotePlaceholder')} onChange={event => setNote(event.target.value)} />
        </div>
        <div className="vtmToggles">
          <label className="vtmToggle" htmlFor="vtmFeedHidden">
            <input id="vtmFeedHidden" type="checkbox" checked={hidden} onChange={event => setHidden(event.target.checked)} />
            <span>{vtmT('hiddenRoll')}</span>
          </label>
        </div>
        <div className="vtmModalActions">
          <button type="submit" className="vtmButton primary" disabled={busy}>{vtmT('feedAction')}</button>
          <button type="button" className="vtmButton ghost" onClick={onClose}>{vtmT('cancel')}</button>
        </div>
      </form>
    </Modal>
  );
};

export default VtmFeedModal;
